import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

export const stripeSetupIntentRequest = (state: Draft<IPaymentState>, { type }: PayloadAction) => {
  state.openRequests = [...state.openRequests, type];
  state.failedRequests = state.failedRequests.filter((actionType) => actionType !== 'payment/stripeSetupIntentFailure');
  state.updatedAt = Date.now();
};

export const stripeSetupIntentSuccess = (state: Draft<IPaymentState>, { payload }: PayloadAction<{ clientSecret: string }>) => {
  state.updatedAt = Date.now();
  state.openRequests = state.openRequests.filter((actionType) => actionType !== 'payment/stripeSetupIntentRequest');
  state.paymentIntentClientSecret = payload.clientSecret;
};

export const stripeSetupIntentFailure = (state: Draft<IPaymentState>, { type }: PayloadAction<{ error: unknown }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [...state.failedRequests, type];
  state.openRequests = state.openRequests.filter((actionType) => actionType !== 'payment/stripeSetupIntentRequest');
};
